const ArrowRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="49" viewBox="0 0 26 49">
      <g fill="none" fillRule="evenodd">
        <g stroke="#979797">
          <path
            d="M1561.432 2144L1536.932 2168.5 1561.432 2193"
            transform="translate(-1536 -2144) matrix(-1 0 0 1 3098.365 0)"
          />
        </g>
      </g>
    </svg>
  );
};

export default ArrowRight;
